import React from 'react';
import Button from '@amzn/awsui-components-console/button';
import styles from './ChatbotWidget.module.scss';

interface ChatSidebarProps {
	currentView: string;
	setSidebarOpen: (open: boolean) => void;
	setCurrentView: (view: 'chat' | 'history' | 'help') => void;
	handleNewConversation: () => void;
}

export const ChatSidebar: React.FC<ChatSidebarProps> = ({
	currentView,
	setSidebarOpen,
	setCurrentView,
	handleNewConversation,
}) => (
	<>
		<div className={styles.sidebarOverlay} onClick={() => setSidebarOpen(false)} />
		<div className={styles.sidebar}>
			<nav className={styles.sidebarNav}>
				<button
					className={`${styles.navItem} ${currentView === 'chat' ? styles.navItemActive : ''}`}
					onClick={() => {
						setCurrentView('chat');
						setSidebarOpen(false);
					}}
				>
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
						<path
							d="M17 9.5C17 13.6421 13.6421 17 9.5 17C8.23 17 7.03 16.68 6 16.13L3 17L3.87 14C3.32 12.97 3 11.77 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
							stroke="currentColor"
							strokeWidth="1.5"
							fill="none"
						/>
					</svg>
					<span>Chat</span>
				</button>
				<button
					className={`${styles.navItem} ${currentView === 'help' ? styles.navItemActive : ''}`}
					onClick={() => {
						setCurrentView('help');
						setSidebarOpen(false);
					}}
				>
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
						<circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" fill="none" />
						<path d="M7.5 7.5C7.5 6.12 8.62 5 10 5C11.38 5 12.5 6.12 12.5 7.5C12.5 8.88 11.38 10 10 10V11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
						<circle cx="10" cy="14" r="1" fill="currentColor" />
					</svg>
					<span>Help</span>
				</button>
			</nav>
			<div className={styles.sidebarFooter}>
				<Button variant="primary" onClick={() => { handleNewConversation(); setSidebarOpen(false); }} iconName="add-plus">
					New conversation
				</Button>
			</div>
		</div>
	</>
);
